module.exports = __webpack_public_path__ + "static/Freshers16-2c64d551162dfbabac75eadb559a22ae.jpg";